import { Component } from '@angular/core';

@Component({
  templateUrl: './charts.html'  
})
export class ChartsComponent { 

    constructor() { }
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/charts/charts-component.ts